import { useTranslation } from '@rhino-project/core/i18n';
import type { RhinoRead } from '@rhino-project/core';
import { formatActivityDate } from '../../utils/dates';

type Event = RhinoRead<'event'>;

type EventListEntry = Pick<Event, 'id' | 'summary' | 'created_at'> & {
  initiator?: Partial<Event['initiator']> | null;
};

interface EventListItemProps {
  event: EventListEntry;
}

const EventListItem = ({ event }: EventListItemProps) => {
  useTranslation();
  return (
    <div className="border-t border-separator px-2 py-3 first:border-t-0">
      <div className="flex items-baseline gap-2">
        <span className="min-w-0 flex-1 wrap-break-word text-sm">
          {`${event.initiator?.display_name ?? ''} ${event.summary}`.trim()}
        </span>
        <span className="shrink-0 whitespace-nowrap text-xs text-muted tabular-nums">
          {formatActivityDate(event.created_at)}
        </span>
      </div>
    </div>
  );
};

export default EventListItem;
